import angular from 'angular';
import AuthenticationService from '../../services/authentication.service';
import cookieService from '../../services/cookie.service';
import AccessTokenService from './accessToken.service';

let accessTokenModule = angular

  .module('app.accessToken', [])

  .service('AccessTokenService', AccessTokenService)
  .service('AuthenticationService', AuthenticationService)
  .service('cookieService', cookieService)

  .factory('accessTokenInjector', ($injector, $log) => {
    'ngInject';

    function avoidTokenInjection(config) {
      const hasToSkipRequest = config.headers['Skip-Request'] === 'true';
      const isStaticFile = config.url.indexOf('uib/template/') !== -1 ||
        config.url.indexOf('bootstrap/') !== -1 ||
        config.url.indexOf('i18n/es.json') !== -1;
      return hasToSkipRequest || isStaticFile;
    }

    return {
      request: (config) => {
        if (avoidTokenInjection(config)) {
          delete config.headers['Skip-Request']; // Delete flag for avoid infinite loop
          $log.info('accessTokenInjector: ignoring ' + config.url);
          return config;
        }

        const AccessTokenService = $injector.get('AccessTokenService');
        const cookieService = $injector.get('cookieService');
        const token = AccessTokenService.getToken();
        const isPortalSenior = cookieService.get('isPortalSenior');
        if (isPortalSenior === 'true'){
          const AuthenticationService = $injector.get('AuthenticationService');
          const employee = AuthenticationService.getEmployeeId();
          if (!config.params) {
            config.params = {};
          }
          config.params.isPortalSenior = true;
          config.params.uid = employee;
        }
        if(token){
          config.headers['Authorization'] = token;
        }
        // $log.info(`accessTokenInjector url: ${JSON.stringify(config)}`);
        return config;
      }
    };
  })

  .config(($httpProvider) => {
    'ngInject';
    $httpProvider.interceptors.push('accessTokenInjector');
  })

  .name;

export default accessTokenModule;



// WEBPACK FOOTER //
// ./client/app/common/interceptors/accessToken/accessToken.js